const selectors = {
  classInfo: (state) => state.classDetails.classInfo,
  loadingClassInfoStatus: (state) => state.classDetails.loadingClassInfoStatus,
  classAppointments: (state) => state.classDetails.classAppointments,
  loadingAppointmentsStatus: (state) =>
    state.classDetails.loadingAppointmentsStatus,
  submittedValuesForCalculation: (state) =>
    state.classDetails.submittedValuesForCalculation,
  scheduleCalculation: (state) => state.classDetails.scheduleCalculation,
  schedule: (state) => state.classDetails.schedule,
  pricing: (state) => state.classDetails.pricing,
  getClassScheduleListStatus: (state) =>
    state.classDetails.getClassScheduleListStatus,
  classDeletingStatus: (state) => state.classDetails.classDeletingStatus,
  setActivationStatus: (state) => state.classDetails.setActivationStatus,
  dancers: {
    list: (state) => state.classDetails.dancers.list,
    loadingClassDancersStatus: (state) =>
      state.classDetails.dancers.loadingClassDancersStatus,
    currentPage: (state) => state.classDetails.dancers.currentPage,
  },
  recipientsList: (state) => state.classDetails.recipientsList,
  loadingRecipientsStatus: (state) =>
    state.classDetails.loadingRecipientsStatus,
  loadedAppointments: (state) => state.classDetails.loadedAppointments,
  loadedClassDancers: (state) => state.classDetails.loadedClassDancers,
  loadedClassSchedule: (state) => state.classDetails.loadedClassSchedule,
  loadedClassPricing: (state) => state.classDetails.loadedClassPricing,
  loadedClassMedia: (state) => state.classDetails.loadedClassMedia,
};

export { selectors };
